import { jsx as _jsx } from "react/jsx-runtime";
const SvgLolGold = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.05896 7.5C5.99196 7.5 7.55896 5.933 7.55896 4C7.55896 2.067 5.99196 0.5 4.05896 0.5C2.12596 0.5 0.55896 2.067 0.55896 4C0.55896 5.933 2.12596 7.5 4.05896 7.5ZM6.47563 4C6.47563 5.33469 5.39365 6.41667 4.05896 6.41667C2.72427 6.41667 1.64229 5.33469 1.64229 4C1.64229 2.66531 2.72427 1.58333 4.05896 1.58333C5.39365 1.58333 6.47563 2.66531 6.47563 4ZM6.97563 4C6.97563 5.61083 5.66979 6.91667 4.05896 6.91667C2.44813 6.91667 1.14229 5.61083 1.14229 4C1.14229 2.38917 2.44813 1.08333 4.05896 1.08333C5.66979 1.08333 6.97563 2.38917 6.97563 4Z",
		fill: "currentColor"
	})
});
export default SvgLolGold;
